import React from 'react'
import { observer } from 'mobx-react'
import {
  useModelKey,
  useModelValue,
  useValue
} from '@morningtrain/react-resources'
import ButtonWithIcon from 'ui/buttons/ButtonWithIcon'
import AddToCartOnClick from 'services/cart/AddToCartOnClick'
import SVGIcon from 'ui/helpers/SVGIcon'

function AddToCart (props) {
  const id = useModelKey()
  const name = useValue('domain')
  const price = useValue('discounted_price')
  const quantity = useModelValue('quantity')

  return (
    <AddToCartOnClick id={id} quantity={quantity} name={name} price={price}>
      <ButtonWithIcon color='outlinePrimary' text='Læg i kurv' iconPath={<SVGIcon className='-ml-1 mr-2 h-5 w-5' type='cart' />} />
    </AddToCartOnClick>
  )
}

export default observer(AddToCart)
